import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithFtp_1 from '../../../../../libraries/Images/createAConnectionWithFtp_1.png';
import createAConnectionWithFtp_2 from '../../../../../libraries/Images/createAConnectionWithFtp_2.png';
import createAConnectionWithFtp_3 from '../../../../../libraries/Images/createAConnectionWithFtp_3.png';
import createAConnectionWithFtp_4 from '../../../../../libraries/Images/createAConnectionWithFtp_4.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithftp">
                1.&nbsp;{translate('createaconnectionwithftp')}
            </Typography>
            <p>Click "Add New" to create the connection.</p>
            <Zoom>
                <img src={createAConnectionWithFtp_1} width="75%" />
            </Zoom>
            <p>A list of applications that can be linked will appear, select "FTP" from among them.</p>
            <Zoom>
                <img src={createAConnectionWithFtp_2} width="75%" />
            </Zoom>
            <p>After you click "FTP", please enter the required values and then click OK button to finish.</p>
            <Zoom>
                <img src={createAConnectionWithFtp_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>You will see an FTP card once the connection is successfully created.</p>
            <Zoom>
                <img src={createAConnectionWithFtp_4} width="50%" />
            </Zoom>
            <p>Use the <strong>Provider ID</strong> included in this tag to perform the steps in FTP.</p>
            <br/>
        </Box>
    );
}
export default withTranslate(En);